import React from "react";
import { connect } from "formik";
import { MoneyInput } from "components/Global/FormikMaterial";

import LateralField from "./LateralField";
import ViewOnlyDiv from "./ViewOnlyDiv";

const SideLabelCalculatedField = ({ label, calculationFunc, formik, isIndented, hasBorder }) => (
  <LateralField label={label}>
    <ViewOnlyDiv hasBorder={hasBorder} isIndented={isIndented}>{calculationFunc(formik.values)}</ViewOnlyDiv>
  </LateralField>
);
export default connect(SideLabelCalculatedField);
